import React from 'react';

import { SankeyExcelBindingContext } from '../../contexts/sankeyExcelBindingContext';
import { useSankeyExcelBindingProviderValue } from '../../utils/addin/excel';
import { useOfficeContext } from '../../utils/addin/office';

type Props = {
  children: React.ReactNode;
};

/*
 * This provider is responsible for providing the context for the Sankey Excel bindings. See the hook for more details.
 * It is only rendered when the user is in Excel.
 */
const SankeyExcelBindingProvider: React.FC<Props> = ({ children }) => {
  const { isExcel } = useOfficeContext();
  return isExcel ? (
    <SankeyExcelBindingContext.Provider
      value={useSankeyExcelBindingProviderValue()}
    >
      {children}
    </SankeyExcelBindingContext.Provider>
  ) : (
    <>{children}</>
  );
};

export default SankeyExcelBindingProvider;
